export const _modalsFr = {
    newGame: {
        title: 'Créer une nouvelle partie',
        gameName: 'Nom de la partie',
    },
    connectionError: {
        title: 'Connexion perdue avec le serveur',
        attemps: 'Tentative de reconnexion',
        success: 'Connexion avec le serveur rétablie.',
    },
    alert: {
        title: 'Alerte',
        close: 'Fermer',
    },
};

export const _modalsEn = {
    newGame: {
        title: 'Create a new game',
        gameName: 'Name of the game',
    },
    connectionError: {
        title: 'Lost connection with server',
        attemps: 'Attempting to reconnect',
        success: 'Connection to the server restored.',
    },
    alert: {
        title: 'Alert',
        close: 'Close',
    },
};

export const _modalsDe = {
    newGame: {
        title: 'Neues Spiel erstellen',
        gameName: 'Name des Spiels',
    },
    connectionError: {
        title: 'Verbindung zum Server verloren',
        attemps: 'Versuch der Wiederherstellung der Verbindung',
        success: 'Verbindung zum Server wiederhergestellt.',
    },
    alert: {
        title: 'Alarm',
        close: 'Schließen',
    },
};
